import { cva } from 'class-variance-authority';

export const callOutContainer = cva(
  [
    'dark flex max-w-[800px] items-center gap-4 rounded-lg border-[1.5px] border-solid border-primary-300 p-6 sm:gap-6 sm:p-8',
  ],
  {
    variants: {
      color: {
        green: ['bg-primary-50 text-primary-900'],
      },
      hasMedia: {
        true: ['flex-row gap-4 sm:gap-6'],
        false: [''],
      },
    },
    defaultVariants: {
      color: 'green',
      hasMedia: false,
    },
  },
);
